module.exports = __webpack_public_path__ + "img/close-icon.a4dc7eab.svg";